<template>
  <el-row :gutter="10">
    <el-col :span="14">
      <PackageSizeTable :orderCode="orderCode" :disabled="disabled" />
    </el-col>
    <el-col :span="10">
      <PackageDocTable :orderCode="orderCode" :disabled="disabled" />
    </el-col>
  </el-row>
</template>
<script>
import PackageSizeTable from './components/package-size'
import PackageDocTable from './components/package-doc'
export default {
  components: { PackageSizeTable, PackageDocTable },
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
}
</script>
